import { render } from "./VsSelectGroup.vue?vue&type=template&id=37d22ca4"
import script from "./VsSelectGroup.vue?vue&type=script&lang=js"
export * from "./VsSelectGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__